<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="items"
      :acesso-disable="acessoDisable"
      :footer-props="{
        'items-per-page-text':'Linhas por página',
        'page-text': '{0}-{1} de {2}',
        'items-per-page-all-text': 'Todos',
      }"
    >
      <template v-slot:no-data>
        Sem dados
      </template>
      <template #[`item.nome`]="{ item }">
        <router-link
          :to="{ name: 'perfil', params: { id: item.id } }"
          class="text--primary text-truncate cursor-pointer text-decoration-none"
        >
          <div class="d-flex align-center">
            <v-avatar
              :color="`${$vuetify.theme.dark ? 'primary' : '#DCDCDC'}`"
              size="32"
            >
              <span
                :class="`${$vuetify.theme.dark ? 'white--text' : 'primary--text'} font-weight-bold`"
              >
                {{ item.nome.toUpperCase().charAt(0) }}{{ item.nome.toUpperCase().charAt(1) }}
              </span>
            </v-avatar>
            <div class="d-flex flex-column ms-3">
              {{ item.nome.slice(0,51) }}
            </div>
          </div>
        </router-link>
      </template>

      <template #[`item.descricao`]="{ item }">
        <div class="d-flex align-center">
          {{ item.descricao ? item.descricao.slice(0,80) : "" }}
        </div>
      </template>

      <template #[`item.ativo`]="{ item }">
        <v-chip
          class="v-chip-light-bg font-weight-semibold text-capitalize"
          small
          :class="`${item.ativo ? 'success--text' : 'secondary--text'}`"
          :color="`${item.ativo ? 'success' : 'secondary'}`"
        >
          {{ item.ativo ? 'Ativo' : 'Inativo' }}
        </v-chip>
      </template>

      <template #[`item.actions`]="{ item }">
        <v-menu
          bottom
          left
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              v-bind="attrs"
              class="ml-n5"
              v-on="on"
              color="primary"
              @click="ativarOuInativarItem(item)"
            >
              <v-icon>
                {{ icons.mdiDotsVertical }}
              </v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              v-if="acessoDisable"
            >
              <v-list-item-title
                role="button"
                class="d-flex"
                @click="openDialogAtivarOuInativarItem"
              >
                <v-icon
                  size="20"
                  class="mr-1"
                >
                  {{ isPerfilAtivo ? icons.mdiCloseThick : icons.mdiCheckBold }}
                </v-icon>
                <span class="text-capitalize">{{ isPerfilAtivoMensagem }}</span>
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
    </v-data-table>

    <!-- dialog -->
    <v-dialog
      v-model="dialogAtivarOuInativarItem"
      max-width="500"
      persistent
    >
      <v-card>
        <v-card-title class="headline text-capitalize">
          {{ isPerfilAtivoMensagem }}
        </v-card-title>
        <v-card-text>{{ `Tem certeza que vai ${isPerfilAtivoMensagem} este perfil?` }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="error"
            outlined
            @click="closeDialogAtivarOuInativarItem"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="success"
            @click="confirmarAtivacaoOuInativacaoItem"
          >
            <v-progress-circular
              v-if="loading"
              indeterminate
              color="secundary"
            ></v-progress-circular>
            <span v-else>OK</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mdiCheckBold, mdiCloseThick, mdiDotsVertical } from '@mdi/js'
import { ref } from '@vue/composition-api'
import Vue from 'vue'
import PerfilService from '@/services/modules/PerfilService'

export default {
  props: {
    items: {
      type: Array,
      default: () => {},
    },
    acessoDisable: {
      type: Boolean,
      default: () => true,
    },
  },

  setup(props, { emit }) {
    const dialogAtivarOuInativarItem = ref(false)
    const loading = ref(false)
    const perfilId = ref(0)
    const isPerfilAtivo = ref(undefined)
    const isPerfilAtivoMensagem = ref('')

    const ativarOuInativarItem = item => {
      perfilId.value = item.id
      isPerfilAtivo.value = item.ativo
      isPerfilAtivoMensagem.value = item.ativo ? 'inativar' : 'ativar'
    }
    const openDialogAtivarOuInativarItem = () => {
      dialogAtivarOuInativarItem.value = true
    }
    const closeDialogAtivarOuInativarItem = () => {
      dialogAtivarOuInativarItem.value = false
    }
    const confirmarAtivacaoOuInativacaoItem = () => {
      loading.value = true
      PerfilService
        .ativarOuInativar(perfilId.value, {
          ativar: !isPerfilAtivo.value,
        })
        .then(() => {
          Vue.$toast.success(`${isPerfilAtivo.value ? 'Inativação' : 'Ativação'} realizada com sucesso.`)
          emit('confirmar-inativacao')
        })
        .finally(() => {
          closeDialogAtivarOuInativarItem()
          loading.value = false
        })
    }

    return {
      dialogAtivarOuInativarItem,
      loading,
      isPerfilAtivo,
      isPerfilAtivoMensagem,
      ativarOuInativarItem,
      openDialogAtivarOuInativarItem,
      closeDialogAtivarOuInativarItem,
      confirmarAtivacaoOuInativacaoItem,
      icons: {
        mdiCheckBold,
        mdiCloseThick,
        mdiDotsVertical,
      },
      headers: [
        { text: 'NOME', value: 'nome' },
        { text: 'DESCRIÇÃO', value: 'descricao' },
        { text: 'STATUS', value: 'ativo' },
        {
          text: 'OPÇÔES',
          value: 'actions',
          align: 'center',
        },
      ],
    }
  },
}
</script>
